// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__10Wx2","loaderOuter":"PageOverlayLoader_loaderOuter__3nLz4"};